<template>
  <el-container>
    <el-header class='form-header' style="height: 80px; background-color: #494949;">
      <img src="../../public/images/yunda logo yellow.png" alt="yundaLogo" style="width: 90px;">
      <div class='back-home' v-on:click="$emit('to-homepage')">返回首页</div>
    </el-header>
    <el-main style="min-height: 70vh;" class='form-main'>
      <div style="width:100%;">
        <el-steps :active="active" finish-status="success" align-center style="width:100%;">
          <el-step title="寄件人信息"></el-step>
          <el-step title="收件人信息"></el-step>
          <el-step title="包裹信息"></el-step>
          <el-step title="附加信息"></el-step>
          <el-step title="确认信息"></el-step>
        </el-steps>
      </div>
      <div>
        <div class='step1' v-show="active === 0">
          <div class='from-shop'>
            <el-card>
              <div style="width:100%;display:flex;flex-direction:row;padding:12px 12px;border-bottom:1px solid #e0e0e0;box-sizing:border-box" @click="shipFrom = 'Yunda Address'">
                <el-radio v-model="shipFrom" label="Yunda Address" style="font-weight:bold;color:#757575;">使用韵达芝加哥地址</el-radio>
              </div>
              <div style="width:100%;display:flex;flex-direction:column;padding:32px 12px;box-sizing:border-box">
                <span style="width:100%;text-align:left; padding-left: 34px;">{{ selectedYundaStore.name }}</span>
                <span style="width:100%;text-align:left;padding-top:8px;display:flex;align-items:center; padding-top: 12px"><i class="material-icons" style="color: #333">phone</i>{{ selectedYundaStore.phoneStr }}</span>
                <span style="width:100%;text-align:left;padding-top:8px;display:flex;align-items:center; padding-top: 12px"><i class="material-icons" style="color: #333">location_on</i>{{ selectedYundaStore.addressStr }}</span>
              </div>
              <div style="width:100%;display:flex;flex-direction:row;padding:0px 12px;box-sizing:border-box">
                <el-button type="primary" plain :disabled="shipFrom !== 'Yunda Address'" @click="toStep2">下一步：收件人信息 <i class="el-icon-arrow-right el-icon-right"></i></el-button>
              </div>
            </el-card>
          </div>
          <div class="from-home">
            <el-card>
              <div style="width:100%;display:flex;flex-direction:row;padding:12px 12px;border-bottom:1px solid #e0e0e0;box-sizing:border-box" @click="shipFrom = 'Customize Address'">
                <el-radio v-model="shipFrom" label="Customize Address" style="font-weight:bold;color:#757575">使用我的地址</el-radio>
              </div>
              <div style="width:100%;padding:12px 12px;box-sizing:border-box;position:relative">
                <el-form :rules="rules" :disabled="shipFrom === 'Yunda Address'" :model="customSendAddress" ref="step1Form">
                  <el-form-item label="姓名" prop="name">
                    <el-input placeholder="填写寄件人姓名" v-model="customSendAddress.name" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="电话" prop="phone">
                    <el-input placeholder="填写寄件人电话" type="number" v-model="customSendAddress.phone" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="地址" prop="address1">
                    <el-input placeholder="填写寄件人详细地址" v-model="customSendAddress.address1" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="Apt / Suite #" prop="address2">
                    <el-input placeholder="填写 Apt/Suite #" v-model="customSendAddress.address2" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="城市"  prop="city">
                    <el-input placeholder="填写寄件人城市" v-model="customSendAddress.city" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="州" prop="state">
                    <el-input placeholder="填写寄件人所在州" v-model="customSendAddress.state" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="邮政编码" prop="postal">
                    <el-input placeholder="填写寄件人邮政编码" type="number" v-model="customSendAddress.postal" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="城市" prop="country">
                    <el-input placeholder="填写寄件人城市" v-model="customSendAddress.country" disabled></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div style="width:100%;display:flex;flex-direction:row;padding:0px 12px;box-sizing:border-box">
                <el-button type="primary" plain :disabled="shipFrom === 'Yunda Address'" @click="toStep2">下一步：收件人信息 <i class="el-icon-arrow-right el-icon-right"></i></el-button>
              </div>
            </el-card>
          </div>
        </div>
        <div class='step2' v-show="active === 1">
          <div class="ship-to">
            <el-card>
              <div style="width:100%;display:flex;flex-direction:row;padding:12px 12px;font-size:16px;font-weight:bold;border-bottom:1px solid #e0e0e0;box-sizing:border-box">收件人信息</div>
              <div style="width:100%;padding:12px 12px;box-sizing:border-box;position:relative">
                <el-form :rules="rulesReceiver" :model="receiveInfo" ref="step2Form">
                  <el-form-item label="姓名" prop="name">
                    <el-input placeholder="填写收件人姓名" v-model="receiveInfo.name" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="联系方式" prop="phone">
                    <el-input placeholder="填写收件人手机号码" type="number" v-model="receiveInfo.phone" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="身份证号码" prop="ID">
                    <el-input placeholder="填写收件人身份证号码" v-model="receiveInfo.ID" clearable></el-input>
                  </el-form-item>
                  <el-form-item label='省（自治区） / 市 / 区' prop='province'>
                    <el-row>
                      <el-col :span='24' style="display:flex;">
                        <el-cascader :options="locationOption" v-model="selectedRegion" placeholder="选择 省（自治区） / 市 / 区" style="width:100%;"></el-cascader>
                      </el-col>
                    </el-row>
                  </el-form-item>
                  <el-form-item label="详细地址" prop="addressInfo">
                    <el-input placeholder="填写收件人详细地址" v-model="receiveInfo.addressInfo" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="邮政编码" prop="postal">
                    <el-input placeholder="填写收件人邮政编码" type="number" v-model="receiveInfo.postal" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="国家" prop="country">
                    <el-input placeholder="填写收件人国家" v-model="receiveInfo.country" disabled></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="buttons-set-5">
                <el-button type="info" icon="el-icon-arrow-left" plain @click="active = 0">上一步：寄件人信息</el-button>
                <el-button class="button-2" type="primary" plain @click="toStep3">下一步：包裹信息 <i class="el-icon-arrow-right el-icon-right"></i></el-button>
              </div>
            </el-card>
          </div>
        </div>
        <div class='step3' v-show="active === 2">
          <div class='pack-detail'>
            <el-card>
              <div style="width:100%;display:flex;flex-direction:row;padding:12px 12px;font-size:16px;font-weight:bold;border-bottom:1px solid #e0e0e0;box-sizing:border-box">包裹信息</div>
              <div style="width:100%;padding:12px 12px;box-sizing:border-box;position:relative">
                <el-form :model="packDetail" ref="step3Form">
                  <!-- <el-form-item label="Weight (LB)" prop="weight">
                    <el-input placeholder="Estimate your package weight(LB)" v-model="packDetail.weight" clearable></el-input>
                  </el-form-item> -->
                  <el-form-item :label="'物品 ' + (index + 1)"  v-for="(item, index) in packDetail.items" :key="item.key">
                      <el-row style="display:flex;justify-content:space-between">
                        <el-col :span="14">
                          <el-form-item style="margin-bottom:12px;display: flex;">
                            <el-select placeholder="选择物品分类" v-model="item.category">
                              <el-option v-for="item in categoryOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="4">
                          <el-button type="danger" icon="el-icon-delete" circle @click="deleteItem(item)" size="small"></el-button>
                        </el-col>
                      </el-row>
                      <el-form-item v-show="item.category">
                        <el-input placeholder='填写物品品牌及名称' v-model="item.name">
                          <template slot="prepend">品牌及名称</template>
                        </el-input>
                      </el-form-item>
                      <el-form-item v-show="item.category">
                        <el-input placeholder='填写物品数量' type="number" v-model="item.qty">
                          <template slot="prepend">数量</template>
                        </el-input>
                      </el-form-item>
                      <el-form-item v-show="item.category">
                        <el-input placeholder='填写物品单价' type="number" v-model="item.price">
                          <template slot="prepend">单价 $</template>
                        </el-input>
                      </el-form-item>
                      <el-form-item v-show="item.category">
                        <el-input placeholder='填写物品总重' type="number" v-model="item.weight">
                          <template slot="prepend">此物品总重 / 磅</template>
                          <!-- <template slot="append">
                            <el-tooltip content="Total weight for this item to estimate your shipping fee." placement="top">
                              <i class="el-icon-info"></i>
                            </el-tooltip>
                          </template> -->
                        </el-input>
                      </el-form-item>
                      <el-form-item v-show="categoryRule[item.category]">
                        <el-input placeholder='填写物品规格' v-model="item.spec">
                          <template slot="prepend">规格</template>
                          <el-select v-model="item.specUnit" slot="append" placeholder="选择单位" class="specSelect">
                            <el-option label="克 g" value="克 g"></el-option>
                            <el-option label="毫升 mL" value="毫升 mL"></el-option>
                            <el-option label="粒 tablets or capsules" value="粒 tablets or capsules"></el-option>
                            <el-option label="盎司 oz" value="盎司 oz"></el-option>
                            <el-option label="Other" value="Other"></el-option>
                          </el-select>
                        </el-input>
                      </el-form-item>
                  </el-form-item>
                  <div style="width:100%;margin-top:16px;box-sizing:border-box;display:flex;justify-content:flex-end;">
                    <el-button icon="el-icon-plus" circle @click="addItem"></el-button>
                  </div>
                </el-form>
                <div style="width:100%;text-align:left;color:#f56c6c;font-size:14px">{{ warningTxt }}</div>
              </div>
              <div class="buttons-set-5">
                <el-button type="info" icon="el-icon-arrow-left" plain @click="active = 1">上一步：收件人信息</el-button>
                <el-button class="button-2" type="primary" plain @click="toStep4">下一步：附加信息 <i class="el-icon-arrow-right el-icon-right"></i></el-button>
              </div>
            </el-card>
          </div>
        </div>
        <div class='step4' v-show="active === 3">
          <div class='add-info'>
            <el-card>
              <div style="width:100%;display:flex;flex-direction:row;padding:12px 12px;font-size:16px;font-weight:bold;border-bottom:1px solid #e0e0e0;box-sizing:border-box">附加信息</div>
              <div style="width:100%;padding:12px 12px;box-sizing:border-box;position:relative">
                <el-form :rules="rulesAddInfo" :model="addInfo" ref="step4Form">
                  <el-form-item label="是否需要包装 Packing box by store?" prop='packing' style="display: flex;flex-direction: column; text-align:left">
                    <div @click="selectPacking(true)">
                      <el-radio v-model="addInfo.packing" label="是 Yes (包税模式运费较高，B2C运费无影响)"></el-radio>
                    </div>
                    <div @click="selectPacking(false)">
                      <el-radio v-model="addInfo.packing" label="否 No (包税模式运费较低，B2C运费无影响)"></el-radio>
                    </div>
                  </el-form-item>
                  <el-form-item label="选择您需要的保费 Insurance Fee" prop='insurance' style="display: flex;flex-direction: column; text-align:left">
                    <div @click="insuranceFee(0)">
                      <el-radio v-model="addInfo.insurance" label="Free（免费），如包裹丢失最高赔付$100"></el-radio>
                    </div>
                    <div @click="insuranceFee(5)">
                      <el-radio v-model="addInfo.insurance" label="$5，如包裹丢失最高赔付$200"></el-radio>
                    </div>
                    <div @click="insuranceFee(10)">
                      <el-radio v-model="addInfo.insurance" label="$10，如包裹丢失最高赔付$300"></el-radio>
                    </div>
                    <div @click="insuranceFee(15)">
                      <el-radio v-model="addInfo.insurance" label="$15，如包裹丢失最高赔付$400"></el-radio>
                    </div>
                  </el-form-item>
                  <el-form-item label="请选择税费模式" prop='shippingMethod' style="display: flex;flex-direction: column; text-align:left">
                    <div>
                      <div @click="shippingMethod('b2c')">
                        <el-radio v-model="addInfo.shippingMethod" label="b2c">B2C (电商模式)</el-radio>
                        <div style="margin-left: 24px">
                          <div> 寄送速度: 标准 </div>
                          <div> 税费: $ {{shippingFee.tax}} </div>
                          <div> 寄送费: $ {{shippingFee.b2c}} </div>
                          <div> 打包方式: {{packData.addInfo.packaged ? '打包' : '不打包'}}</div>
                          <div> 保险费: $ {{packData.addInfo.insuranceFee}}</div>
                          <div> 总计: $ {{b2cTotal()}}</div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div @click="shippingMethod('noTax')">
                        <el-radio v-model="addInfo.shippingMethod" label="noTax">Tax Free (包税模式)</el-radio>
                        <div style="margin-left: 24px">
                          <div> 寄送速度: 标准 </div>
                          <div> 税费: $ 0.00 </div>
                          <!-- packaged -->
                          <div v-if="addInfo.packaged"> 寄送费 (打包): $ {{shippingFee.packaged}}</div>
                          <!-- unpackaged -->
                          <div v-if="!addInfo.packaged"> 寄送费 (不打包): $ {{shippingFee.unpackaged}}</div>
                          <div> 打包方式: {{packData.addInfo.packaged ? '打包' : '不打包'}}</div>
                          <div> 保险费: $ {{packData.addInfo.insuranceFee}}</div>
                          <div> 总计: $ {{noTaxTotal()}}</div>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item label="留言 Remark" prop='remark'>
                    <el-input placeholder="有其他需要告知我们的，就在这里留言吧" v-model="addInfo.remark" clearable></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="buttons-set-5">
                <el-button type="info" icon="el-icon-arrow-left" plain @click="active = 2">上一步：包裹信息</el-button>
                <el-button class="button-2" type="primary" plain @click="toStep5">下一步：确认信息 <i class="el-icon-arrow-right el-icon-right"></i></el-button>
              </div>
            </el-card>
          </div>
        </div>
        <div class='step5' v-show="active === 4">
          <div class='confirm-info'>
            <el-card>
              <div style="width:100%;display:flex;flex-direction:row;align-items:flex-end;justify-content:space-between;padding:12px 12px;font-size:16px;font-weight:bold;border-bottom:1px solid #e0e0e0;box-sizing:border-box">寄件人信息<el-button size="small" icon="el-icon-edit" circle @click="active = 0"></el-button></div>
              <div style="width:100%;padding:12px 12px;box-sizing:border-box;position:relative;">
                <div style="font-size: 15px;font-weight:600;text-align:left;color:rgba(0,0,0,0.95)">{{ packData.shipFrom.name }}</div>
                <div style="font-size: 15px;text-align:left; margin-top: 16px;display:flex;color:rgba(0,0,0,0.85)"><span style="color:rgba(0,0,0,0.65);width:64px;font-size:14px">联系方式</span> {{ packData.shipFrom.phone }}</div>
                <div style="font-size: 15px;text-align:left; margin-top: 5px;display:flex;color:rgba(0,0,0,0.70)"><div style="width:65px;color:rgba(0,0,0,0.65);font-size:14px">详细地址</div>{{ packData.shipFrom.address1 }} {{ packData.shipFrom.address2 }}</div>
                <div style="font-size: 15px;text-align:left;color:rgba(0,0,0,0.70);padding-left:65px;">{{ packData.shipFrom.city }}, {{ packData.shipFrom.state }}, {{ packData.shipFrom.postal }}</div>
                <div style="font-size: 15px;text-align:left;color:rgba(0,0,0,0.70);padding-left:65px">{{ packData.shipFrom.country }}</div>
              </div>
            </el-card>
            <el-card style="margin-top:24px">
              <div style="width:100%;display:flex;flex-direction:row;align-items:flex-end;justify-content:space-between;padding:12px 12px;font-size:16px;font-weight:bold;border-bottom:1px solid #e0e0e0;box-sizing:border-box">收件人信息<el-button size="small" icon="el-icon-edit" circle @click="active = 1"></el-button></div>
              <div style="width:100%;padding:12px 12px;box-sizing:border-box;position:relative;">
                <div style="font-size: 15px;font-weight:600;text-align:left;color:rgba(0,0,0,0.95)">{{ packData.shipTo.name }}</div>
                <div style="font-size: 15px;text-align:left; margin-top: 16px;display:flex;color:rgba(0,0,0,0.85)"><span style="color:rgba(0,0,0,0.65);width:80px;font-size:14px">身份证号码</span>{{ packData.shipTo.ID }}</div>
                <div style="font-size: 15px;text-align:left; margin-top: 5px;display:flex;color:rgba(0,0,0,0.85)"><span style="color:rgba(0,0,0,0.65);width:64px;font-size:14px">联系方式</span>{{ packData.shipTo.phone }}</div>
                <div style="font-size: 15px;text-align:left; margin-top: 5px;display:flex;color:rgba(0,0,0,0.70);word-wrap: break-word;"><div style="width:64px;color:rgba(0,0,0,0.65);font-size:14px">详细地址</div>{{ packData.shipTo.addressInfo }}</div>
                <div style="font-size: 15px;text-align:left;color:rgba(0,0,0,0.70);padding-left:65px">{{ packData.shipTo.province }}, {{ packData.shipTo.city }}, {{ packData.shipTo.district }}</div>
                <div style="font-size: 15px;text-align:left;color:rgba(0,0,0,0.70);padding-left:65px">{{ packData.shipTo.postal }}</div>
                <div style="font-size: 15px;text-align:left;color:rgba(0,0,0,0.70);padding-left:65px">{{ packData.shipTo.country }}</div>
              </div>
            </el-card>
            <el-card style="margin-top:24px">
              <div style="width:100%;display:flex;flex-direction:row;align-items:flex-end;justify-content:space-between;padding:12px 12px;font-size:16px;font-weight:bold;border-bottom:1px solid #e0e0e0;box-sizing:border-box">包裹信息<el-button size="small" icon="el-icon-edit" circle @click="active = 2"></el-button></div>
              <div style="width:100%;padding:12px 12px;box-sizing:border-box;position:relative;">
                <!-- <div style="font-size: 15px;text-align:left;color:rgba(0,0,0,0.85);display:flex;"><span style="color:rgba(0,0,0,0.65);width:50px;font-size:14px">包裹总重</span>{{ packData.packDetail.weight }} LB</div> -->
                <div style="font-size: 15px;text-align:left;font-weight:bold; margin-top: 8px;display:flex;color:rgba(0,0,0,0.85)">物品</div>
                <div v-for="(item, index) in packData.packDetail.items" v-bind:key="item.key" style="font-size: 15px;text-align:left; margin-top: 6px;display:flex;color:rgba(0,0,0,0.80)">
                  <div style="display:flex;flex-direction:column">
                    <div style="display: flex;font-size: 15px;text-align:left;color:rgba(0,0,0,0.95);"><div style="width:50px;font-size: 14px;color:rgba(0,0,0,0.65);">物品 {{ index + 1 }}</div>{{ item.name }}</div>
                    <div style="font-size: 15px;text-align:left;color:rgba(0,0,0,0.85);display:flex;padding-left:50px;margin-top:2px;word-wrap: break-word;"><span style="color:rgba(0,0,0,0.65);font-size:14px;width:64px;">类别</span>{{ item.category }}</div>
                    <div style="font-size: 15px;text-align:left;color:rgba(0,0,0,0.85);display:flex;padding-left:50px;margin-top:2px;"><span style="color:rgba(0,0,0,0.65);font-size:14px;width:64px;">单价 </span>$ {{ item.price }}</div>
                    <div style="font-size: 15px;text-align:left;color:rgba(0,0,0,0.85);display:flex;padding-left:50px;margin-top:2px;"><span style="color:rgba(0,0,0,0.65);font-size:14px;width:64px;">数量 </span>{{ item.qty }}</div>
                    <div style="font-size: 15px;text-align:left;color:rgba(0,0,0,0.85);display:flex;padding-left:50px;margin-top:2px;"><span style="color:rgba(0,0,0,0.65);font-size:14px;width:64px;">总重 </span>{{ item.weight }} 磅</div>
                    <div style="font-size: 15px;text-align:left;color:rgba(0,0,0,0.85);display:flex;padding-left:50px;margin-top:2px;" v-show="item.spec !== ''"><span style="color:rgba(0,0,0,0.65);font-size:14px;width:64px;">规格单位.</span> {{ item.spec }} {{ item.specUnit }}</div>
                  </div>
                </div>
              </div>
            </el-card>
            <el-card style="margin-top:24px">
              <div style="width:100%;display:flex;flex-direction:row;align-items:flex-end;justify-content:space-between;padding:12px 12px;font-size:16px;font-weight:bold;border-bottom:1px solid #e0e0e0;box-sizing:border-box">附加信息<el-button size="small" icon="el-icon-edit" circle @click="active = 3"></el-button></div>
              <div style="width:100%;padding:12px 12px;box-sizing:border-box;position:relative;">
                <div style="font-size: 14px;text-align:left;color:rgba(0,0,0,0.85);display: flex;"><span style="color:rgba(0,0,0,0.65);font-size:14px;width:64px;">打包方式: </span>{{ packData.addInfo.packaged ? '打包' : '不打包' }}</div>
                <div style="font-size: 14px;text-align:left; margin-top: 4px;display:flex;color:rgba(0,0,0,0.85)"><span style="color:rgba(0,0,0,0.65);font-size:14px;width:64px;">保险费</span> $ {{ packData.addInfo.insuranceFee }}</div>
                <div style="font-size: 14px;text-align:left; margin-top: 4px;display:flex;color:rgba(0,0,0,0.85);word-wrap: break-word;"><span style="color:rgba(0,0,0,0.65);font-size:14px;width:64px;">备注</span> {{ packData.addInfo.remark }}</div>
              </div>
            </el-card>
            <el-card style="margin-top:24px">
              <div style="width:100%;display:flex;flex-direction:row;align-items:flex-end;justify-content:space-between;padding:12px 12px;font-size:16px;font-weight:bold;border-bottom:1px solid #e0e0e0;box-sizing:border-box">总计: $ {{ packData.totalFee }}</div>
              <div style="width:100%;padding:12px 12px;box-sizing:border-box;position:relative;">
                <div style="font-size: 14px;text-align:left;color:rgba(0,0,0,0.85);display: flex;"><span style="color:rgba(0,0,0,0.65);font-size:14px;width:64px;">寄送费</span> $ {{ packData.shippingFee }}</div>
                <div style="font-size: 14px;text-align:left;margin-top: 4px;display:flex;color:rgba(0,0,0,0.85)"><span style="color:rgba(0,0,0,0.65);font-size:14px;width:64px;">税费</span> $ {{ packData.tax }}</div>
                <div style="font-size: 14px;text-align:left;margin-top: 4px;display:flex;color:rgba(0,0,0,0.85)"><span style="color:rgba(0,0,0,0.65);font-size:14px;width:64px;">保险费</span> $ {{ packData.addInfo.insuranceFee }}</div>
                <div style="font-size: 14px;text-align:left;margin-top: 4px;display:flex;color:rgba(0,0,0,0.85)"><span style="color:rgba(0,0,0,0.65);font-size:14px;width:64px;">打包方式: </span>{{ packData.addInfo.packaged ? '打包' : '不打包' }}</div>
                <div style="font-size: 14px;text-align:left;margin-top: 24px;display:flex;color:rgba(0,0,0,0.65)">请核对您的订单信息</div>
              </div>
              <div style="width:100%;display:flex;flex-direction:row;padding:4px 12px 4px 12px;box-sizing:border-box">
                <el-button type='info' plain v-on:click="cancelOrder">取消</el-button>
                <el-button type="success" icon="el-icon-success" v-on:click="toSubmit" plain>确认并提交</el-button>
              </div>
            </el-card>
          </div>
        </div>
      </div>
      <div v-show="orderSuccess" class="order-success">
        <div class='success-info'>
          <div class="success-image">
            <h2>On the way ...</h2>
          </div>
          <div class="success-content">
            <div>
              <div style="font-size:20px;font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">- Thank you! -</div>
              <div style="font-size:20px;margin-top:16px;font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;"> 我们已经成功收到您的运单信息</div>
              <div style="font-size:20px;margin-top:16px;font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;"> 您的运单号为: <span>{{ confirmShippingNo }}</span></div>
              <div style="font-size:20px;margin-top:16px;font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;"> 您将收到一封发送给您的确认电子邮件</div>
              <div style="font-size:20px;margin-top:16px;font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;"> 请您将包裹送至韵达芝加哥店铺</div>
              <div style="font-size:20px;margin-top:16px;font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;"> 地址为：{{ selectedYundaStore.addressStr }}</div>
            </div>
            <div>
              <div style="font-size:20px;margin-top:16px;font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;"> 您可以登录 <strong>cn.yundaorders.com</strong> 管理您的运单</div>
            </div>
            <div style="padding-bottom: 56px;">
              <!-- <div style="font-size:20px;margin-top:9vh;text-decoration:underline;font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;cursor:pointer; font-weight: 900" @click="finishShipping">Finish</div> -->
              <el-button type="primary" round @click="finishShipping" style="margin-top:5vh;">完成</el-button>
              <div style="font-size:14px;font-weight:bold;margin-top:18px;font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">- 您也可以 -</div>
              <!-- <div style="font-size:20px;margin-top:12px;text-decoration:underline;font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;cursor:pointer; font-weight: 900" @click="restartShipping">Start A New Shipping</div> -->
              <el-button type="primary" round plain @click="restartShipping" style="margin-top:12px;">填写新运单</el-button>
            </div>
          </div>
        </div>
      </div>
      <div v-show="orderFail" class="order-success">
        <div class='fail-info'>
          <div class="success-image">
            <h2>Errr ...</h2>
          </div>
          <div class="success-content">
            <div>
              <div style="font-size:20px;font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">- Sorry... -</div>
              <div style="font-size:20px;margin-top:16px;font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;"> 我们没能收到您的运单信息</div>
              <div style="font-size:20px;margin-top:16px;font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;"> 我们会尽快解决这个问题</div>
              <div style="font-size:20px;margin-top:16px;font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;"> 在此之前</div>
            </div>
            <div>
              <div style="font-size:20px;margin-top:16px;font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;"> 您可以点击重试</div>
            </div>
            <div style="padding-bottom: 56px;">
              <!-- <div style="font-size:20px;margin-top:8vh;text-decoration:underline;font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;cursor:pointer" @click="toSubmit">Try Again</div> -->
              <el-button type="primary" round @click="toSubmit" style=";margin-top:5vh;">重试</el-button>
              <div style="font-size:14px;font-weight:bold;margin-top:18px;font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">- OR -</div>
              <!-- <div style="font-size:20px;margin-top:12px;text-decoration:underline;font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;cursor:pointer" @click="closeFail">Quit</div> -->
              <el-button type="primary" round plain @click="closeFail" style="margin-top:12px;">退出</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-main>
    <el-footer style="height: 80px;color:#494949" class='form-footer'>Powered by <a href="https://studioscreation.com" class="studio-s">Studio S</a> </el-footer>
  </el-container>
</template>

<script>
import { ChinaRegion } from '../../public/js/ChinaRegion'
import { postShippingOrder, calcShippingFee } from '../../public/js/shipping'

function getInitData () {
  return {
    selectStore: true,
    selectedStoreIndex: 0,

    newForm: true,
    showTooltip: true,
    active: 0,
    orderSuccess: false,
    orderFail: false,
    shipFrom: 'Yunda Address',
    customSendAddress: {
      name: '',
      phone: '',
      address1: '',
      address2: '',
      city: 'Chicago',
      state: 'IL',
      postal: '',
      country: 'United States'
    },
    receiveInfo: {
      name: '',
      phone: '',
      ID: '',
      addressInfo: '',
      district: '',
      city: '',
      province: '',
      postal: '',
      country: '中国'
    },
    selectedRegion: [],
    packDetail: {
      items: [{
        category: '',
        key: Date.now(),
        name: '',
        qty: '',
        price: '',
        spec: '',
        specUnit: '',
        weight: ''
      }]
    },
    addInfo: {
      packing: '是 Yes (包税模式运费较高，B2C运费无影响)',
      packingFee: 0,
      insurance: 'Free（免费），如包裹丢失最高赔付$100',
      insuranceFee: 0,
      shippingMethod: 'b2c',
      packaged: true,
      remark: ''
    },
    rules: {
      name: [
        { required: true, message: '请填写寄件人姓名', trigger: 'blur' }
      ],
      phone: [
        { required: true, message: '请填写寄件人手机号码', trigger: 'blur' },
        { type: 'string', pattern: /^[0-9]*$/, message: '寄件人手机号码应为数字', trigger: 'change' },
        { min: 10, max: 10, message: '寄件人手机号码（美国）应为10位电话号码', trigger: 'change' }
      ],
      address1: [
        { required: true, message: '请填写寄件人详细地址', trigger: 'blur' }
      ],
      address2: [
        { required: false }
      ],
      city: [
        { required: true, message: '请填写寄件人城市', trigger: 'blur' }
      ],
      state: [
        { required: true, message: '请填写寄件人所在州', trigger: 'blur' }
      ],
      postal: [
        { required: true, message: '请填写寄件人邮政编码', trigger: 'blur' },
        { type: 'string', pattern: /^[0-9]*$/, message: '寄件人邮政编码应为数字', trigger: 'change' },
        { min: 5, max: 5, message: '寄件人邮政编码（美国）应为5位数字', trigger: 'change' }
      ]
    },
    rulesReceiver: {
      name: [
        { required: true, message: '请填写收件人姓名', trigger: 'blur' }
      ],
      phone: [
        { required: true, message: '请填写收件人电话号码', trigger: 'blur' },
        { type: 'string', pattern: /^[0-9]*$/, message: '寄件人邮政编码应为纯数字', trigger: 'change' },
        { min: 11, max: 11, message: '收件人电话号码（中国）应为11位数字', trigger: 'change' }
      ],
      addressInfo: [
        { required: true, message: '请填写收件人详细地址', trigger: 'blur' }
      ],
      province: [
        { required: true, message: '请选择收件人 省/市/区', trigger: 'change' }
      ],
      postal: [
        { required: true, message: '请填写收件人邮政编码', trigger: 'blur' },
        { type: 'string', pattern: /^[0-9]*$/, message: '收件人邮政编码应为纯数字', trigger: 'change' },
        { min: 6, max: 6, message: '收件人邮政编码（中国）应为6位', trigger: 'change' }
      ],
      ID: [
        { required: true, message: '请填写收件人身份证号码', trigger: 'blur' },
        { type: 'string', pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/, message: '请输入合法身份证号码', triger: 'blur' }
      ]
    },
    // rulesItems: {
    //   weight: [
    //     { required: true, message: 'Please estimate package weight(lb)', trigger: 'blur' },
    //     { type: 'string', validator: validateWeight, message: 'Weight should be a number greater than 0', trigger: 'change' }
    //   ]
    // },
    rulesAddInfo: {
      packing: [
        { required: true, message: '请选择包装方式', trigger: 'change' }
      ],
      insurance: [
        { required: true, message: '请为您的包裹选择保险', trigger: 'change' }
      ],
      remark: [
        { required: false }
      ]
    },
    locationOption: ChinaRegion,
    categoryOption: [{
      value: 'Health_Supplement',
      label: '保健品'
    }, {
      value: 'Baby_Formula',
      label: '奶粉'
    }, {
      value: 'Baby_Care',
      label: '母婴'
    }, {
      value: 'Clothes',
      label: '衣服'
    }, {
      value: 'Daily_Necessities',
      label: '生活用品'
    }, {
      value: 'Shoes',
      label: '鞋类'
    }, {
      value: 'Bag',
      label: '箱包，皮具'
    }, {
      value: 'Electronics',
      label: '电子产品'
    }, {
      value: 'Accessories',
      label: '饰品'
    }, {
      value: 'Cosmetic',
      label: '化妆品'
    }, {
      value: 'Watch',
      label: '手表'
    }, {
      value: 'Other',
      label: '其他'
    }],
    categoryRule: {
      Health_Supplement: true,
      Baby_Formula: true,
      Baby_Care: false,
      Clothes: false,
      Daily_Necessities: false,
      Shoes: false,
      Bag: false,
      Electronics: false,
      Accessories: false,
      Cosmetic: false,
      Watch: false,
      other: false
    },
    warningTxt: '',
    confirmShippingNo: ''
  }
}

export default {
  name: 'ShopForm',
  props: ['tempEmail', 'selectedYundaStore'],
  data () {
    return getInitData()
  },
  timers: {
    validateWatcher: {
      time: 1000,
      autostart: true,
      repeat: true,
      immediate: true
    }
  },
  methods: {
    closeFail: function () {
      this.orderFail = false
    },
    toStep2: function () {
      if (this.shipFrom === 'Yunda Address') {
        this.active = 1
      } else {
        this.$refs['step1Form'].validate((valid) => {
          // valid = true
          if (valid) {
            this.active = 1
          } else {
            // console.log('error submit!!')
          }
        })
      }
    },
    toStep3: function () {
      this.$refs['step2Form'].validate((valid) => {
        // valid = true
        if (valid) {
          this.active = 2
        } else {
          // console.log('error submit!!')
        }
      })
    },
    toStep4: function () {
      this.$refs['step3Form'].validate((valid) => {
        // valid = true
        if (valid) {
          var items = this.packDetail.items
          var categoryRule = this.categoryRule
          for (var i = 0; i < items.length; i++) {
            if (items[i].category === '') {
              this.warningTxt = '请选择物品 ' + (i + 1) + ' 分类'
              return
            }
            if (items[i].name === '') {
              this.warningTxt = '请填写物品 ' + (i + 1) + ' 品牌名称'
              return
            }
            if (items[i].qty === '') {
              this.warningTxt = '请填写物品 ' + (i + 1) + ' 数量'
              return
            }
            if (!(!isNaN(parseInt(items[i].qty)) && parseInt(items[i].qty) > 0)) {
              this.warningTxt = '物品 ' + (i + 1) + ' 数量应大于0'
              return
            }
            if (items[i].price === '') {
              this.warningTxt = '请填写物品 ' + (i + 1) + ' 价格'
              return
            }
            if (!(!isNaN(parseFloat(items[i].price)) && parseFloat(items[i].price) >= 0)) {
              this.warningTxt = '物品 ' + (i + 1) + ' 价格应大于等于0'
              return
            }
            if (items[i].weight === '') {
              this.warningTxt = '请填写物品 ' + (i + 1) + ' 总重'
              return
            }
            if (!(!isNaN(parseFloat(items[i].weight)) && parseFloat(items[i].weight) > 0)) {
              this.warningTxt = '物品 ' + (i + 1) + ' 总重应大于0'
              return
            }
            if (categoryRule[items[i].category] && items[i].spec === '') {
              this.warningTxt = '请填写物品 ' + (i + 1) + ' 规格'
              return
            }
            if (categoryRule[items[i].category] && items[i].spec === '') {
              if (!((!isNaN(parseFloat(items[i].spec))) && (parseFloat(items[i].spec) > 0))) {
                this.warningTxt = '物品 ' + (i + 1) + ' 规格应大于等于0'
                return
              }
            }
            if (categoryRule[items[i].category] && items[i].specUnit === '') {
              this.warningTxt = '请选择物品 ' + (i + 1) + ' 规格单位'
              return
            }
          }
          this.warningTxt = ''
          this.active = 3
        } else {
          // console.log('error submit!!')
        }
      })
    },
    toStep5: function () {
      this.$refs['step3Form'].validate((valid) => {
        // valid = true
        if (valid) {
          this.active = 4
        } else {
          // console.log('error submit!!')
        }
      })
    },
    addItem: function () {
      if (this.packDetail.items.length < 10) {
        this.packDetail.items.push({
          category: '',
          key: Date.now(),
          name: '',
          qty: '',
          price: '',
          spec: '',
          specUnit: '',
          weight: ''
        })
      } else {
        this.$notify.info({
          title: '提示 Tips',
          message: '</p>单包裹种类上限为10种</p><p>Limited to 10 items in a package</p>',
          dangerouslyUseHTMLString: true
        })
      }
    },
    deleteItem: function (item) {
      var index = this.packDetail.items.indexOf(item)
      if (index !== -1 && this.packDetail.items.length > 1) {
        this.packDetail.items.splice(index, 1)
      } else if (index !== -1 && this.packDetail.items.length === 1) {
        this.$notify.info({
          title: '提示 Tips',
          message: '</p>至少包含一个物品</p><p>At least one item in a package</p>',
          dangerouslyUseHTMLString: true
        })
      }
    },
    shippingMethod: function (val) {
      this.addInfo.shippingMethod = val
    },
    selectPacking: function (packing) {
      if (packing) {
        this.addInfo.packing = '是 Yes (包税模式运费较高，B2C运费无影响)'
        this.addInfo.packaged = true
      } else {
        this.addInfo.packing = '否 No (包税模式运费较低，B2C运费无影响)'
        this.addInfo.packaged = false
      }
    },
    insuranceFee: function (insuranceFee) {
      if (insuranceFee === 0) {
        this.addInfo.insurance = 'Free（免费），如包裹丢失最高赔付$100'
        this.addInfo.insuranceFee = insuranceFee.toFixed(2)
      } else if (insuranceFee === 5) {
        this.addInfo.insurance = '$5，如包裹丢失最高赔付$200'
        this.addInfo.insuranceFee = insuranceFee.toFixed(2)
      } else if (insuranceFee === 10) {
        this.addInfo.insurance = '$10，如包裹丢失最高赔付$300'
        this.addInfo.insuranceFee = insuranceFee.toFixed(2)
      } else if (insuranceFee === 15) {
        this.addInfo.insurance = '$15，如包裹丢失最高赔付$400'
        this.addInfo.insuranceFee = insuranceFee.toFixed(2)
      }
    },
    b2cTotal: function () {
      let total = parseFloat(this.shippingFee.b2c) + parseFloat(this.shippingFee.tax) + parseFloat(this.addInfo.insuranceFee)
      return total.toFixed(2)
    },
    noTaxTotal: function () {
      let total = 0
      if (this.addInfo.packaged) {
        total = parseFloat(this.shippingFee.packaged) + parseFloat(this.addInfo.insuranceFee)
      } else {
        total = parseFloat(this.shippingFee.unpackaged) + parseFloat(this.addInfo.insuranceFee)
      }
      return total.toFixed(2)
    },
    cancelOrder: function () {
      this.$confirm('您填写的信息将被删除. 确认取消订单?', 'Warning', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('to-homepage')
      }).catch(err => {
        // console.log(err)
      })
    },
    toSubmit: function () {
    // submit order to firebase
      let order = {}
      order = this.packData
      order.stamp = Date.now()
      order.date = getLocalDate(order.stamp)
      order.inStore = false
      order.owner = ''
      order.email = this.tempEmail
      order.status = 'Online'
      order.saveToAddressBook = {
        alias: '',
        save: false,
        docId: ''
      }
      postShippingOrder(order).then(orderData => {
        // console.log('Success post the order =>', orderData)
        this.orderSuccess = true
        this.orderFail = false
        this.confirmShippingNo = orderData.shippingNo
      }).catch(err => {
        // console.log('Unable to post order =>', err)
        this.orderFail = true
        this.orderSuccess = false
      })
    },
    restartShipping: function () {
      Object.assign(this.$data, getInitData())
    },
    finishShipping: function () {
      this.$emit('to-homepage')
      Object.assign(this.$data, getInitData())
    },
    validateWatcher: function () {
      if (this.newForm) {
        this.$refs['step1Form'].clearValidate()
        this.$refs['step2Form'].resetFields()
        this.$refs['step3Form'].resetFields()
        this.newForm = false
        // console.log('clear validation')
      }
    }
  },
  computed: {
    packData: function () {
      var packData = {}

      // Add store tag
      packData.storeGroup = this.selectedYundaStore.storeGroup ? this.selectedYundaStore.storeGroup : 'NOT_ASSIGNED'
      packData.longCode = this.selectedYundaStore.longCode ? this.selectedYundaStore.longCode : ''

      // Shipping From Address
      if (this.shipFrom === 'Yunda Address') {
        let shipAddress = {
          name: 'Please use store name',
          phone: 'Please use store phone',
          address1: 'Please use store address',
          address2: '',
          city: 'Chicago',
          state: 'IL',
          postal: '60616',
          country: 'United States'
        }
        if (this.selectedYundaStore && this.selectedYundaStore.shippingAddress) {
          shipAddress = this.selectedYundaStore.shippingAddress
        }
        packData.shipFrom = shipAddress
      } else {
        packData.shipFrom = this.customSendAddress
      }

      // Shipping To Address
      packData.shipTo = this.receiveInfo

      // Package Info
      var packDetail = this.packDetail
      var items = packDetail.items
      var categoryRule = this.categoryRule
      for (var i = 0; i < items.length; i++) {
        for (var category in categoryRule) {
          if (items[i].category === category) {
            if (!categoryRule[category]) {
              items[i].spec = ''
              items[i].specUnit = ''
            }
          }
        }
      }
      packDetail.items = items
      packData.packDetail = packDetail

      let fees = this.shippingFee

      if (this.addInfo.shippingMethod === 'b2c') {
        packData.tax = fees.tax
        packData.shippingFee = fees.b2c
      } else {
        packData.tax = '0.00'
        packData.shippingFee = this.addInfo.packaged ? fees.packaged : fees.packaged
      }

      var totalFee
      if (this.addInfo.shippingMethod === 'b2c') {
        totalFee = this.b2cTotal()
      } else if (this.addInfo.shippingMethod === 'noTax') {
        totalFee = this.noTaxTotal()
      } else {
        totalFee = 'Invalid shipping method'
      }
      packData.totalFee = totalFee

      // Additional Info
      packData.addInfo = this.addInfo

      return packData
    },
    shippingFee: function () {
      var receiveProvince = this.receiveInfo.province
      return calcShippingFee(this.packDetail.items, receiveProvince)
    }
  },
  watch: {
    selectedRegion: function () {
      this.receiveInfo.province = this.selectedRegion[0]
      this.receiveInfo.city = this.selectedRegion[1]
      this.receiveInfo.district = this.selectedRegion[2]
    }
  }
}
// var validateWeight = (rule, value, callBack) => {
//   if (parseFloat(value) <= 0) {
//     return callBack(new Error('Weight should be a number greater than 0'))
//   } else {
//     callBack()
//   }
// }

function getLocalDate (stamp) {
  let dateObj = new Date(stamp)
  let year = dateObj.getFullYear()
  let month = String(dateObj.getMonth() + 1)
  if (month.length < 2) {
    month = '0' + month
  }
  let date = String(dateObj.getDate())
  if (date.length < 2) {
    date = '0' + date
  }
  return year + '-' + month + '-' + date
}
</script>

<style>
h2 {
  font-size: 35pt;
}
.font-bold {
  font-weight: bold;
}
.form-header {
  padding: 0 20px;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
}
.form-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: medium;
}
.back-home {
  font-size: 18px;
  color: whitesmoke;
  font-weight: normal;
  cursor: pointer;
}
.studio-s {
  margin-left: 4px;
  font-size: medium;
  color: #c62828;
  text-decoration: none;
}
.form-main {
  padding: 64px 120px;
}
.step1{
  padding-top: 56px;
  margin: auto;
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.from-shop {
  width: 48%;
}
.from-home {
  width: 48%;
}
.el-form-item__label {
  position: relative;
  text-align: left;
}
.step2 {
  padding-top: 56px;
  margin: auto;
  width: 90%;
}
.ship-to {
  width: 48%;
  margin: auto;
}
.step3 {
  padding-top: 56px;
  margin: auto;
  width: 90%;
}
.pack-detail {
  width: 48%;
  margin: auto;
}
.specSelect {
  width: 200px;
}
.step4 {
  padding-top: 56px;
  margin: auto;
  width: 90%;
}
.add-info {
  width: 48%;
  margin: auto;
}
.step5 {
  padding-top: 56px;
  margin: auto;
  width: 90%;
}
.confirm-info {
  width: 48%;
  margin: auto;
}
.order-success {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  background-color: rgba(77,77,77,0.4);
  z-index: 1001;
  animation: showConfirm 0.4s ease;
}
.success-info {
  color: rgba(0, 0, 0, 0.6);
  width: 700px;
  /* height: 80vh; */
  margin: auto;
  background-image: url(../../public/images/yunda-b-6.jpg);
  background-position: left top;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 20px;
  padding: 10px;
  box-sizing: border-box;
  box-shadow: 0 28px 50px -25px #494949;
  overflow: auto;
}
.fail-info {
  color: rgba(0, 0, 0, 0.6);
  width: 700px;
  height: 80vh;
  margin: auto;
  background-image: url(../../public/images/yunda-back.jpg);
  background-position: left top;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 20px;
  padding: 10px;
  box-sizing: border-box;
  box-shadow: 0 28px 50px -25px #494949;
  overflow: auto;
}
.success-image {
  width: 680px;
  height: 17vh;
  border-radius: 5PX 5px 0 0;
  color: rgba(49, 49, 49, 0.2);
  font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  display: flex;
  align-items:flex-start;
  justify-content: flex-end;
}
.success-content {
  width: 100%;
  /* height: 50vh; */
  border-radius: 0 0 5px 5px;
  background-color: rgba(256,256,256,0.7);
  box-sizing: border-box;
  padding-top: 5vh;
  color: rgba(0, 0, 0, 0.95)
}
.buttons-set-5 {
  width: 100%;
  text-align: left;
  padding:0px 12px;
  box-sizing:border-box
}
@keyframes showConfirm {
  from { opacity: 0; }
  to { opacity: 1; }
}
@media (max-width: 1440px) {
  .step1{
    width: 95%;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .step2{
    margin: auto;
    width: 95%;
  }
  .step3{
    margin: auto;
    width: 95%;
  }
  .step4{
    margin: auto;
    width: 95%;
  }
  .step5{
    margin: auto;
    width: 95%;
  }
  .from-shop {
    width: 60%;
  }
  .from-home {
    margin-top: 16px;
    width: 60%;
  }
  .ship-to {
    width: 60%;
  }
  .pack-detail {
    width: 60%;
  }
  .add-info {
    width: 60%;
  }
  .confirm-info {
    width: 60%;
  }
  .el-card__body {
    padding: 20px 4px;
  }
}
@media (max-width: 1024px) {
  .form-main {
    padding: 24px 12px;
    font-size: small;
  }
  .step1{
    width: 95%;
    margin: auto;
    display: flex;
    flex-direction: column;
    padding-top: 24px;
  }
  .step2{
    padding-top: 24px;
    margin: auto;
    width: 95%;
  }
  .step3{
    padding-top: 24px;
    margin: auto;
    width: 95%;
  }
  .step4{
    padding-top: 24px;
    margin: auto;
    width: 95%;
  }
  .step5{
    padding-top: 24px;
    margin: auto;
    width: 95%;
  }
  .from-shop {
    width: 100%;
  }
  .from-home {
    margin-top: 16px;
    width: 100%;
  }
  .ship-to {
    width: 100%;
  }
  .pack-detail {
    width: 100%;
  }
  .add-info {
    width: 100%;
  }
  .confirm-info {
    width: 100%;
  }
  .el-card__body {
    padding: 20px 4px;
  }
}
@media (max-width: 812px) {
  .specSelect {
    width: 80px;
  }
  .el-message-box {
    width: 300px;
  }
  .el-step__title {
    font-size: 14px;
  }
  .buttons-set-5 {
    text-align: left;
    width: auto;
    padding:0px 12px;
    box-sizing:border-box
  }
  .button-2 {
    margin: 12px 0 0 0 !important;
  }
  /* .success-info {
  color: rgba(0, 0, 0, 0.6);
  width: 95%;
  height: 90vh;
  margin: auto;
  background:url(../../public/images/yunda-b-7.jpg);
  background-size: right;
  background-position: left top;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 20px;
  padding: 10px;
  box-sizing: border-box;
  box-shadow: 0 28px 50px -25px #494949;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.success-image {
  width: 100%;
  border-radius: 5PX 5px 0 0;
  color: rgba(49, 49, 49, 0.2);
  font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  display: flex;
  align-items:flex-start;
  justify-content: flex-end;
}
.success-content {
  width: 100%;
  border-radius: 0 0 5px 5px;
} */
.el-form-item {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
}
@media (max-width: 700px) {
  .specSelect {
    width: 80px;
  }
  .el-message-box {
    width: 300px;
  }
  .el-step__title {
    font-size: 14px;
  }
  .success-info {
  color: rgba(0, 0, 0, 0.6);
  width: 95%;
  height: 90vh;
  margin: auto;
  background:url(../../public/images/yunda-b-7.jpg);
  background-size: right;
  background-position: left top;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 20px;
  padding: 10px;
  box-sizing: border-box;
  box-shadow: 0 28px 50px -25px #494949;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.fail-info {
  color: rgba(0, 0, 0, 0.6);
  width: 95%;
  height: 90vh;
  margin: auto;
  background:url(../../public/images/yunda-back.jpg);
  background-size: right;
  background-position: left top;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 20px;
  padding: 10px;
  box-sizing: border-box;
  box-shadow: 0 28px 50px -25px #494949;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.success-image {
  width: 100%;
  height: 17vh;
  border-radius: 5PX 5px 0 0;
  color: rgba(49, 49, 49, 0.2);
  font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  display: flex;
  align-items:flex-start;
  justify-content: flex-end;
}
.success-content {
  width: 100%;
  border-radius: 0 0 5px 5px;
}
.el-form-item {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
}
</style>
